(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["product-mini-source-climbing-pyramid"] && !Shopify.designMode) return;
  try {
    function hideMissingMiniProductImage(image) {
    var media = image.closest('.product-kits-source--miniquadro-climbing-pyramid .mini-product__media');
    if (!media) return;

    media.hidden = true;
    var row = media.closest('.mini-product__row');
    if (row) row.classList.add('mini-product__row--media-missing');
  }

  document.addEventListener('error', function (event) {
    if (!(event.target instanceof HTMLImageElement)) return;
    hideMissingMiniProductImage(event.target);
  }, true);

  function checkMiniProductImages() {
    document.querySelectorAll('.product-kits-source--miniquadro-climbing-pyramid .mini-product__media img').forEach(function (image) {
      if (image.complete && image.naturalWidth === 0) hideMissingMiniProductImage(image);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', checkMiniProductImages, { once: true });
  } else {
    checkMiniProductImages();
  }

  window.addEventListener('load', checkMiniProductImages, { once: true });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["support-launcher"] && !Shopify.designMode) return;
  try {
    (() => {
    'use strict'

    const root = document.getElementById('LocalSupportLauncher')

    if (!root || root.dataset.initialized === 'true') {
      return
    }

    root.dataset.initialized = 'true'

    const launcher = root.querySelector(
      '.local-support-launcher__button'
    )
    const panel = root.querySelector(
      '.local-support-launcher__panel'
    )
    const closeButton = root.querySelector(
      '.local-support-launcher__close'
    )
    const consentButton = root.querySelector(
      '.local-support-launcher__consent'
    )
    const declineButton = root.querySelector(
      '.local-support-launcher__decline'
    )
    const errorMessage = root.querySelector(
      '.local-support-launcher__error'
    )
    const liveRegion = root.querySelector(
      '.local-support-launcher__live'
    )
    const loadingMessage = root.querySelector(
      '.local-support-launcher__message--loading'
    )

    const controllerWaitTimeout = 4000
    const intercomActionTimeout = 12000

    let actionInProgress = false

    function getController() {
      return window.QuadroIntercom || null
    }

    function controllerHasConsent(controller) {
      if (!controller) {
        return false
      }

      try {
        if (typeof controller.hasConsent === 'function') {
          return Boolean(controller.hasConsent())
        }

        if (typeof controller.getState === 'function') {
          const currentState = controller.getState()

          return Boolean(
            currentState &&
              currentState.consent === 'granted'
          )
        }
      } catch (error) {
        return false
      }

      return false
    }

    function waitForController(timeout = controllerWaitTimeout) {
      const existingController = getController()

      if (existingController) {
        return Promise.resolve(existingController)
      }

      return new Promise((resolve) => {
        let completed = false
        let timerId = 0

        function finish(controller) {
          if (completed) {
            return
          }

          completed = true

          window.clearTimeout(timerId)

          document.removeEventListener(
            'quadro:intercom:controller-ready',
            handleControllerReady
          )

          resolve(controller || null)
        }

        function handleControllerReady() {
          finish(getController())
        }

        document.addEventListener(
          'quadro:intercom:controller-ready',
          handleControllerReady
        )

        timerId = window.setTimeout(() => {
          finish(getController())
        }, timeout)

        /*
          Avoid missing the event if the controller became ready between the
          first synchronous check and registration of the event listener.
        */
        const controllerAfterRegistration = getController()

        if (controllerAfterRegistration) {
          finish(controllerAfterRegistration)
        }
      })
    }

    function openPanel(showError = false) {
      errorMessage.hidden = !showError
      panel.hidden = false
      launcher.setAttribute('aria-expanded', 'true')
      closeButton.focus()
    }

    function closePanel(restoreFocus = true) {
      panel.hidden = true
      errorMessage.hidden = true
      launcher.setAttribute('aria-expanded', 'false')

      if (restoreFocus) {
        launcher.focus()
      }
    }

    function setLoading(isLoading) {
      launcher.disabled = isLoading
      launcher.setAttribute('aria-busy', String(isLoading))
      consentButton.disabled = isLoading
      declineButton.disabled = isLoading

      liveRegion.textContent = isLoading
        ? loadingMessage.textContent.trim()
        : ''
    }

    function normalizeControllerResult(result) {
      if (result === true) {
        return 'opened'
      }

      if (result === false || result === null || result === undefined) {
        return 'error'
      }

      if (
        typeof result === 'object' &&
        typeof result.status === 'string'
      ) {
        return result.status
      }

      return 'error'
    }

    function isSuccessfulStatus(status) {
      return (
        status === 'opened' ||
        status === 'ready' ||
        status === 'success'
      )
    }

    function isConsentRequiredStatus(status) {
      return (
        status === 'consent-required' ||
        status === 'unset' ||
        status === 'denied' ||
        status === 'revoked'
      )
    }

    function runWithTimeout(action) {
      if (actionInProgress) {
        return Promise.resolve({
          status: 'busy',
        })
      }

      actionInProgress = true
      setLoading(true)

      const controllerAction = Promise.resolve()
        .then(action)
        .then(
          (result) => ({
            status: normalizeControllerResult(result),
          }),
          () => ({
            status: 'error',
          })
        )

      const timeoutAction = new Promise((resolve) => {
        window.setTimeout(() => {
          resolve({
            status: 'timeout',
          })
        }, intercomActionTimeout)
      })

      return Promise.race([
        controllerAction,
        timeoutAction,
      ]).finally(() => {
        actionInProgress = false
        setLoading(false)
      })
    }

    function getGrantAction(controller) {
      /*
        Compatibility with the planned COM-188 controller.
      */
      if (
        controller &&
        typeof controller.grantFromLauncher === 'function'
      ) {
        return () => controller.grantFromLauncher()
      }

      /*
        Compatibility with the currently active intercom.liquid.
      */
      if (
        controller &&
        typeof controller.grant === 'function'
      ) {
        return () => controller.grant(true)
      }

      return null
    }

    async function openIntercom() {
      const controller = getController()

      /*
        The launcher remains immediately responsive even if the Intercom
        controller has not yet been initialized.
      */
      if (!controller) {
        openPanel(false)
        return
      }

      if (!controllerHasConsent(controller)) {
        openPanel(false)
        return
      }

      if (typeof controller.open !== 'function') {
        openPanel(true)
        return
      }

      const result = await runWithTimeout(() => controller.open())

      if (isSuccessfulStatus(result.status)) {
        return
      }

      if (
        isConsentRequiredStatus(result.status) ||
        !controllerHasConsent(controller)
      ) {
        openPanel(false)
        return
      }

      openPanel(true)
    }

    launcher.addEventListener('click', openIntercom)

    closeButton.addEventListener('click', () => {
      closePanel()
    })

    declineButton.addEventListener('click', () => {
      /*
        "Nicht jetzt" only closes the isolated Intercom prompt.
        It does not write an additional consent or denial state.
      */
      closePanel()
    })

    consentButton.addEventListener('click', async () => {
      closePanel(false)

      const controller = await waitForController()

      if (!controller) {
        openPanel(true)
        return
      }

      const grantAction = getGrantAction(controller)

      if (!grantAction) {
        openPanel(true)
        return
      }

      const result = await runWithTimeout(grantAction)

      if (isSuccessfulStatus(result.status)) {
        return
      }

      if (isConsentRequiredStatus(result.status)) {
        openPanel(false)
        return
      }

      openPanel(true)
    })

    document.addEventListener('keydown', (event) => {
      if (event.key === 'Escape' && !panel.hidden) {
        closePanel()
      }
    })
  })()
  } catch(e) { console.error(e); }
})();

})();
